import React, { useState, useEffect } from "react";

import ScaricaButton from "../box_button/scarica_app_button.js";
import ChatAssistenza from "../box_button/chat_assistenza_button.js";
import Promotion from "../box_button/promotion_button.js";

function BoxNavigation() {
    return (
        <>
            {/* <div className="box-navigation-two mt-4">
        
          <ScaricaButton/>
        
          <ChatAssistenza/>
          
            </div> */}

            {/* <Promotion/> */}
        </>
    );
}

export default BoxNavigation;
